export const EXCHANGE_STORAGE_KEY = '@lmg/exchange'
export const EXCHANGE_STORAGE_PROGRAM_SRC = 'lastUsedProgramSrc'
export const EXCHANGE_STORAGE_PROGRAM_DEST = 'lastUsedProgramDest'
export const EXCHANGE_STORAGE_CARD = 'lastUsedCard'

export const RUBLES_EXCHANGE_CURRENCY_FROM = '032'
export const RUBLES_EXCHANGE_CURRENCY_TO = '810'
export const RUBLES_ENTRY_CLASS = 'RUB'
export const ETIKETKA_PARTNER_CURRENCY = 'UNC_BONUS'